import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";

export default function LandingPage() {
  const screenshots = [
    "/screen1.png",
    "/screen2.png",
    "/screen3.png",
    "/screen4.png",
    "/screen5.png",
  ];

  const [currentScreen, setCurrentScreen] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentScreen((prev) => (prev + 1) % screenshots.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [screenshots.length]);

  // Close the mobile menu when the viewport returns to desktop size.
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) setMenuOpen(false);
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") setMenuOpen(false);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="landing">
     <nav className={`navbar ${menuOpen ? "menu-is-open" : ""}`}>
  <div className="logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
    <img
      src="/logo-side-by-side.png"
      alt="Nessefy Logo"
      className="logo-img"
    />
  </div>

  <div className={`nav-links ${menuOpen ? "active" : ""}`}>
    <a href="#features" onClick={() => setMenuOpen(false)}>Features</a>
    <a href="#about" onClick={() => setMenuOpen(false)}>About Us</a>
    <a href="#download" onClick={() => setMenuOpen(false)}>Contact Us</a>
  </div>

  <div className="nav-actions">
    <button className="nav-login" onClick={() => navigate("/login")}>
      Sign In
    </button>

    <button className="nav-btn" onClick={() => navigate("/register")}>
      Join Nessefy
    </button>

    <button
      className={`hamburger ${menuOpen ? "open" : ""}`}
      onClick={() => setMenuOpen(!menuOpen)}
      aria-label="Toggle menu"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</nav>
      <section className="hero">
        <div className="hero-blob blob-1"></div>
        <div className="hero-blob blob-2"></div>
        <div className="hero-blob blob-3"></div>

        <div className="hero-content">
          <p className="hero-badge">AI-powered entrepreneurial ecosystem</p>

          <h1>
            Connect. Create. Grow with{" "}
            <span className="highlight">Nes<span>s</span>efy</span>.
          </h1>

          <p>
            Nessefy is building the operating system for entrepreneurship—a unified
            ecosystem where founders, businesses, freelancers, and innovators can
            network, collaborate, discover services, share knowledge, and unlock new
            opportunities through AI-powered connections.
          </p>

         <div className="hero-buttons">
  <button
    className="primary-btn"
    onClick={() => navigate("/login")}
  >
    Sign In
  </button>

  <button
    className="secondary-btn"
    onClick={() =>
      document
        .getElementById("about")
        ?.scrollIntoView({ behavior: "smooth" })
    }
  >
    Learn More
  </button>
</div>
        </div>

        <div className="hero-explorer">
          <div className="explorer-top">
            <div>
              <span className="explorer-kicker">EXPLORE NESSEFY</span>
              <h3>Choose your path.</h3>
              <p>Every role has a place here. Start with what feels most like you.</p>
            </div>
            <div className="explorer-orbit" aria-hidden="true">
              <span>✦</span>
            </div>
          </div>

          <div className="explorer-paths">

            <div
              className="path-item path-founder"
              onClick={() => navigate("/founder")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") navigate("/founder");
              }}
            >
              <span className="path-icon">🚀</span>
              <span className="path-copy">
                <strong>Founder</strong>
                <small>Build & grow</small>
              </span>
              <span className="path-go">→</span>
            </div>

            <div
              className="path-item path-professional"
              onClick={() => navigate("/businessprofessional")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") navigate("/businessprofessional");
              }}
            >
              <span className="path-icon">🤝</span>
              <span className="path-copy">
                <strong>Business Professional</strong>
                <small>Find your match</small>
              </span>
              <span className="path-go">→</span>
            </div>

            <div
              className="path-item path-freelancer"
              onClick={() => navigate("/freelancer")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") navigate("/freelancer");
              }}
            >
              <span className="path-icon">💼</span>
              <span className="path-copy">
                <strong>Freelancer</strong>
                <small>Find opportunities</small>
              </span>
              <span className="path-go">→</span>
            </div>

            <div
              className="path-item path-rookie"
              onClick={() => navigate("/rookie")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") navigate("/rookie");
              }}
            >
              <span className="path-icon">🌱</span>
              <span className="path-copy">
                <strong>Rookie</strong>
                <small>Start your journey</small>
              </span>
              <span className="path-go">→</span>
            </div>

            <div
              className="path-item path-mentor"
              onClick={() => navigate("/mentor")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") navigate("/mentor");
              }}
            >
              <span className="path-icon">🧠</span>
              <span className="path-copy">
                <strong>Mentor</strong>
                <small>Guide & inspire</small>
              </span>
              <span className="path-go">→</span>
            </div>

            <div
              className="path-item path-investor"
              onClick={() => navigate("/investor")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") navigate("/investor");
              }}
            >
              <span className="path-icon">📈</span>
              <span className="path-copy">
                <strong>Investor</strong>
                <small>Discover opportunities</small>
              </span>
              <span className="path-go">→</span>
            </div>

            <div
              className="path-item path-company"
              onClick={() => navigate("/company")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") navigate("/company");
              }}
            >
              <span className="path-icon">🏢</span>
              <span className="path-copy">
                <strong>Company</strong>
                <small>Join the ecosystem</small>
              </span>
              <span className="path-go">→</span>
            </div>

            <div
              className="path-item path-entrepreneur"
              onClick={() => navigate("/entrepreneur")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") navigate("/entrepreneur");
              }}
            >
              <span className="path-icon">🏢</span>
              <span className="path-copy">
                <strong>Entrepreneur</strong>
                <small>Join the Network</small>
              </span>
              <span className="path-go">→</span>
            </div>

          </div>

          <div className="explorer-footer">
            <span><i></i> 8 paths · one ecosystem</span>
            <span>Tap any path to explore <b>→</b></span>
          </div>
        </div>
      </section>

      <section className="showcase">
        <div className="showcase-content">
          <span className="showcase-tag">Experience the Platform</span>

          <h2>
            Everything entrepreneurs need,
            <br />
            in one ecosystem.
          </h2>

          <p>
            Network with founders, discover opportunities, collaborate with
            professionals, and grow your business through AI-powered recommendations.
          </p>

          <div className="store-buttons">

  <a
    href="https://play.google.com/store/apps/details?id=com.niteshagarwal8290.nessefymobile"
    target="_blank"
    rel="noopener noreferrer"
    className="store-btn"
  >
    <img src="/google-play-badge.png" alt="Google Play" />
  </a>

  <a
    href="#"
    target="_blank"
    rel="noopener noreferrer"
    className="store-btn"
  >
    <img src="/app-store-badge.png" alt="App Store" />
  </a>

</div>

        </div>

        <div className="phone-showcase">
          <div className="floating-ui ui-top-left">🤝 Founder Match</div>
          <div className="floating-ui ui-top-right">🚀 Startup Opportunity</div>
          <div className="floating-ui ui-bottom-left">💡 AI Recommendation</div>
          <div className="floating-ui ui-bottom-right">📈 Growth Insights</div>

          <div className="phone-frame">
            <div className="phone-notch"></div>

            <div className="phone-screen">
              <img
                key={currentScreen}
                src={screenshots[currentScreen]}
                alt="Nessefy App Screenshot"
                className="phone-screenshot"
              />
            </div>
          </div>
        </div>
      </section>

      <section id="features" className="features">
        <div className="features-header">
          <span className="features-tag">Why Nessefy?</span>

          <h2>
            From idea to growth,
            <br />
            Nessefy moves with you.
          </h2>

          <p>
            Nessefy helps entrepreneurs move through the most important stages of
            building: finding the right people, working together, and growing through
            intelligent opportunities.
          </p>
        </div>

        <div className="journey-container">
          <div className="journey-card">
            <div className="journey-step">01</div>
            <div className="journey-icon">🤝</div>
            <h3>Connect</h3>
            <p>
              Discover founders, freelancers, investors, mentors, and professionals
              who align with your goals.
            </p>
          </div>

          <div className="journey-arrow">→</div>

          <div className="journey-card featured-journey">
            <div className="journey-step">02</div>
            <div className="journey-icon">🚀</div>
            <h3>Collaborate</h3>
            <p>
              Exchange ideas, build partnerships, find services, and turn
              conversations into real business opportunities.
            </p>
          </div>

          <div className="journey-arrow">→</div>

          <div className="journey-card">
            <div className="journey-step">03</div>
            <div className="journey-icon">📈</div>
            <h3>Grow</h3>
            <p>
              Use AI recommendations, community knowledge, and business discovery
              tools to scale faster.
            </p>
          </div>
        </div>

        <div className="features-stats">
          <div>
            <h4>AI</h4>
            <p>Smart recommendations</p>
          </div>

          <div>
            <h4>360°</h4>
            <p>Entrepreneur ecosystem</p>
          </div>

          <div>
            <h4>1</h4>
            <p>Unified platform</p>
          </div>
        </div>
      </section>

      <section id="about" className="about">
        <div className="about-content">
          <span className="about-tag">About Nessefy</span>

          <h2>Built for the people who are building the future.</h2>

          <p>
            Nessefy is not just another social platform. It is an entrepreneurial
            ecosystem designed to help founders, freelancers, businesses, and innovators
            find the right people, share knowledge, discover opportunities, and grow
            through AI-powered connections.
          </p>

          <div className="about-points">
            <div>
              <h4>For Founders</h4>
              <p>Find collaborators, co-founders, services, and early opportunities.</p>
            </div>

            <div>
              <h4>For Businesses</h4>
              <p>Discover talent, connect with clients, and build meaningful networks.</p>
            </div>

            <div>
              <h4>For Innovators</h4>
              <p>Turn ideas into conversations, partnerships, and real growth.</p>
            </div>
          </div>
        </div>

        <div className="about-visual">
          <div className="orbit-card about-card-1">Founder</div>
          <div className="orbit-card about-card-2">Freelancer</div>
          <div className="orbit-card about-card-3">Business Professional</div>
          <div className="orbit-card about-card-4">Investor</div>
          <div className="orbit-card about-card-5">Rookie</div>

          <div className="about-center-card">
            <img src="/n-logo.png" alt="Nessefy Logo" />
            <h3>One ecosystem</h3>
            <p>People • Ideas • Opportunities</p>
          </div>
        </div>
      </section>

      <section id="download" className="contact-section">
        <div className="contact-content">
          <span className="contact-tag">Get In Touch</span>

          <h2>
            Let's Build The Future
            <br />
            Together.
          </h2>

          <p>
            Whether you're a founder, freelancer, business owner, investor, or simply
            curious about Nessefy, we'd love to hear from you.
          </p>

          <button
  className="primary-btn"
  onClick={() => navigate("/register")}
>
  Join Nessefy
</button>
        </div>

        <div className="contact-card">
          <h3>Contact Information</h3>

          <div className="contact-item">📧 support@nessefy.com</div>
          <div className="contact-item">📧 nessefy.official@nessefy.com</div>
          <div
  className="contact-item"
  onClick={() => window.open("/", "_self")}
>
  🌐 www.nessefy.com
</div>
          <div className="contact-item">📍 India</div>

          <div className="social-links">
  <a
    href="https://www.instagram.com/nessefy?igsh=MTZjY2trZ29yMzA0"
    target="_blank"
    rel="noopener noreferrer"
    className="social-card"
  >
    <span>📸</span> Instagram
  </a>

  <a
    href="https://www.linkedin.com/company/nessefy/"
    target="_blank"
    rel="noopener noreferrer"
    className="social-card"
  >
    <span>💼</span> LinkedIn
  </a>

  <a
    href="https://www.facebook.com/share/1EAbkvwZdo/"
    target="_blank"
    rel="noopener noreferrer"
    className="social-card"
  >
    <span>📘</span> Facebook
  </a>

  <a
    href="https://x.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="social-card"
  >
    <span>𝕏</span> X
  </a>
</div>
        </div>
      </section>

      <footer className="footer">
  <p>© 2026 Nessefy. All rights reserved.</p>

  <div className="footer-links">
    <span
      onClick={() => navigate("/privacy-policy")}
    >
      Privacy Policy
    </span>

    <span
      onClick={() => navigate("/terms-and-conditions")}
    >
      Terms & Conditions
    </span>
  </div>
</footer>
    </div>
  );
}